import { Vertical } from '@gravitate-js/excalibrr'
import React from 'react'

import { OutageGrid } from './components/Grid'

export function Outages() {
  return (
    <Vertical flex={1}>
      <OutageGrid />
    </Vertical>
  )
}
